import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const SearchIcon16: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M9.74528 10.8887C8.72476 11.6682 7.44953 12.1313 6.06614 12.1313C2.7159 12.1313 0 9.4155 0 6.0654C0 2.7153 2.7159 -0.000488281 6.06614 -0.000488281C9.41637 -0.000488281 12.1323 2.7153 12.1323 6.0654C12.1323 7.44898 11.669 8.72436 10.8892 9.74493L15.7659 14.6215C16.0783 14.9338 16.0783 15.4402 15.7659 15.7526L15.7532 15.7653C15.4409 16.0776 14.9344 16.0776 14.6221 15.7653L9.74528 10.8887ZM10.919 6.0654C10.919 8.74548 8.74632 10.9181 6.06614 10.9181C3.38595 10.9181 1.21323 8.74548 1.21323 6.0654C1.21323 3.38532 3.38595 1.21269 6.06614 1.21269C8.74632 1.21269 10.919 3.38532 10.919 6.0654Z"
          fill={fill}/>
  </svg>

);

export default SearchIcon16;
import React, { FC } from 'react';

type PropsT = {
  fill?: string;
};

const SearchIcon16: FC<PropsT> = ({ fill = 'currentColor' }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M9.74528 10.8887C8.72476 11.6682 7.44953 12.1313 6.06614 12.1313C2.7159 12.1313 0 9.4155 0 6.0654C0 2.7153 2.7159 -0.000488281 6.06614 -0.000488281C9.41637 -0.000488281 12.1323 2.7153 12.1323 6.0654C12.1323 7.44898 11.669 8.72436 10.8892 9.74493L15.7659 14.6215C16.0783 14.9338 16.0783 15.4402 15.7659 15.7526L15.7532 15.7653C15.4409 16.0776 14.9344 16.0776 14.6221 15.7653L9.74528 10.8887ZM10.919 6.0654C10.919 8.74548 8.74632 10.9181 6.06614 10.9181C3.38595 10.9181 1.21323 8.74548 1.21323 6.0654C1.21323 3.38532 3.38595 1.21269 6.06614 1.21269C8.74632 1.21269 10.919 3.38532 10.919 6.0654Z"
          fill={fill}/>
  </svg>

);

export default SearchIcon16;
